import { registerController } from "../registry";

registerController("mobile-nav", (el: HTMLElement) => {
  const toggle = el.querySelector<HTMLButtonElement>("[data-nav-toggle]");
  const menu = el.querySelector<HTMLElement>("[data-nav-menu]");
  if (!toggle || !menu) return;

  // Mark as JS-enhanced so CSS progressive enhancement kicks in
  menu.classList.add("js-enhanced");

  function open(): void {
    menu!.classList.add("is-open");
    toggle!.setAttribute("aria-expanded", "true");
  }

  function close(): void {
    menu!.classList.remove("is-open");
    toggle!.setAttribute("aria-expanded", "false");
  }

  function isOpen(): boolean {
    return menu!.classList.contains("is-open");
  }

  toggle.addEventListener("click", () => {
    if (isOpen()) {
      close();
    } else {
      open();
    }
  });

  // Close on Escape
  document.addEventListener("keydown", (e: KeyboardEvent) => {
    if (e.key === "Escape" && isOpen()) {
      close();
      toggle!.focus();
    }
  });

  // Close when clicking outside the nav
  document.addEventListener("click", (e: MouseEvent) => {
    if (isOpen() && !el.contains(e.target as Node)) {
      close();
    }
  });
});
